export const errors = {
  noEditorExist: 'Edytor nie istnieje',
  B2BTokenRequestFailed:
    'Błąd podczas próby pobrania zasobów partnera. Skontaktuj się z administratorem.',
  emailConfirmCodeIncorrect: 'Nieprawidłowy kod potwierdzający z e-maila',
  authenticatorConfirmIncorrect:
    'Nieprawidłowy kod z aplikacji uwierzytelniającej',
  invalidPassword: 'Nieprawidłowe hasło',
}
